function showBanner({ url, imgSrc, position }) {
  if (position === 'top') {
    const bannerPosTop = document.querySelector('.banner-position_top');
    bannerPosTop.innerHTML = banner();
    bannerPosTop.classList.add('banner-position_show');
  } else if (position === 'bottom') {
    const bannerPosBottom = document.querySelector('.banner-position_bottom');
    bannerPosBottom.innerHTML = banner();
    bannerPosBottom.classList.add('banner-position_show');
  } else {
    throw new Error(`Invalid position: ${position}`);
  }

  function banner() {
    const bannerImg = `<img src="${imgSrc}" class="banner__img" alt="Banner" />`;

    if (url) {
      return `<a href="${url}" class="banner banner_link" target="_blank">${bannerImg}</a>`;
    }
    return `<div class="banner">${bannerImg}</div>`;
  }
}

export function showTopBanner({ url, imgSrc }) {
  showBanner({ position: 'top', url, imgSrc });
}

export function showBottomBanner({ url, imgSrc }) {
  showBanner({ position: 'bottom', url, imgSrc });
}

function onClickBanner(position, cb) {
  const bannerPos = document.querySelector(`.banner-position_${position} a`);
  if (bannerPos) {
    bannerPos.addEventListener('click', cb);
  }
}

export function onClickTopBanner(cb) {
  onClickBanner('top', cb);
}

export function onClickBottomBanner(cb) {
  onClickBanner('bottom', cb);
}
